import ScholarShipTableComponent from "./components/ScholarShipTableComponent";

function ScholarshipReports() {
  return <ScholarShipTableComponent/>
}

export default ScholarshipReports;
